(() => {
  const updateTimer = window.WeakMap ? new WeakMap() : new Map();
  let actionWasAlreadyExecuted = false;

  function executePostponedAction() {
    if (!window.swinger.user.isLoggedIn()) {
      return;
    }

    if (window.swinger.authenticationRequiredElement && window.swinger.authenticationRequiredElement.isConnected) {
      window.setTimeout(() => {
        window.swinger.eventHub.trigger(window.swinger.authenticationRequiredElement, 'swinger:toggle-on');
      }, 1000);
      return;
    }

    const actionToExecuteAfterLogin = window.swinger.storage.get('swinger-action-to-execute-after-login');
    window.swinger.storage.remove('swinger-action-to-execute-after-login');

    if (!actionToExecuteAfterLogin) {
      return;
    }

    if (actionToExecuteAfterLogin.where !== window.location.pathname) {
      return;
    }

    if (actionToExecuteAfterLogin.clickedElementCSSPath) {
      const selector = `${actionToExecuteAfterLogin.clickedElementCSSPath}[data-authentication-required]`;
      const elem = document.querySelector(selector);

      if (elem) {
        window.setTimeout(() => {
          window.swinger.observer.initialize(selector, (elem) => {
            if (actionWasAlreadyExecuted) {
              return;
            }
            actionWasAlreadyExecuted = true;
            window.swinger.eventHub.trigger(elem, 'swinger:toggle-on');
          }, false);
        }, 1000);
      }
    }
  }

  function update(elem) {
    window.clearTimeout(updateTimer.get(elem));
    updateTimer.set(elem, window.setTimeout(() => {
      if (window.swinger.user.isLoggedIn()) {
        elem.removeAttribute('data-popover');
      } else {
        elem.setAttribute('data-popover', JSON.stringify({
          id: 'cta-register',
          backgroundColor: 'white',
          openEvents: 'click',
          closeEvents: '',
          component: 'cta-register',
        }));
      }
    }, 50));
  }

  let wasClicked = false;
  window.swinger.eventHub.register('swinger:toggle-on', '[data-authentication-required]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (elem.scrollIntoView) {
      elem.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'center',
      });
    }

    window.setTimeout(() => {
      if (wasClicked) {
        return;
      }
      wasClicked = true;
      elem.click();
    }, 300);
  });

  window.swinger.observer.initialize('[data-authentication-required]', (elem) => {
    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    });

    document.addEventListener('swinger-widget:rendered', () => {
      update(elem);
    });

    update(elem);

    if (window.swinger.user.isLoggedIn()) {
      return;
    }

    const inPlaceLoginUrl = `${window.swinger.config.assetsBase}/widgets/in-place-registration${!window.swinger.supportsModules ? '.es5' : ''}.js?v=${window.swinger.config.version}`;
    window.swinger.resourceLoader.script(inPlaceLoginUrl);
  });

  window.addEventListener('pageshow', () => {
    executePostponedAction();

    document.addEventListener('swinger.user:authchange', () => {
      executePostponedAction();
    });
  });
})();
